import { makeStyles } from '@material-ui/styles';

export const useProductContainerStyles = makeStyles((theme) => ({
  boxContainer: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #BCBCBC',
    borderLeft: '6px solid #666666',
    borderRadius: '5px',
    opacity: 1,
    marginBottom: 5,
  },
  grid: {
    paddingBottom: (props) => (props.mobile ? 0 : 3),
  },
  image: {
    width: (props) => (props.mobile ? 65 : 75),
    height: (props) => (props.mobile ? 65 : 75),
    marginRight: (props) => (props.mobile ? 15 : 20),
    marginTop: 6,
    marginBottom: 6,
    marginLeft: 6,
    objectFit: 'cover',
  },
  textContainer: {
    flexWrap: (props) => (props.mobile ? 'wrap' : ''),
    maxWidth: '70%',
  },
  text: {
    fontSize: (props) => (props.mobile ? 14 : 15),
    textAlign: 'left',
    color: '#464646',
  },
  title: {
    fontSize: (props) => (props.mobile ? 14 : 15),
    marginBottom: (props) => (props.mobile ? 3 : 5),
    color: theme.palette.primary.main,
    fontWeight: 600,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
